import { I18n } from '@affine/i18n';
import {
  registerDataViewLocaleProvider,
  registerDataViewTranslator,
} from '@blocksuite/affine/blocks/database';

/**
 * Bridges the data-view package's i18n seam to the app i18n. The
 * data-view package ships English fallbacks only; this translator
 * resolves its keys against the `com.streamlain.dataview.*` namespace
 * in the i18n resources (en/de). Registered at module-load time —
 * same pattern as `registerGlobalGroupByConfig` in `./group-by`.
 */
const DATA_VIEW_I18N_PREFIX = 'com.streamlain.dataview.';

registerDataViewTranslator((key, params) => {
  const fullKey = `${DATA_VIEW_I18N_PREFIX}${key}`;
  const translate = (
    I18n as unknown as Record<
      string,
      (args?: Record<string, string | number>) => string
    >
  )[fullKey];
  if (typeof translate !== 'function') {
    return undefined;
  }
  const translated = translate(params);
  // i18next echoes the key back when no resource exists — treat that
  // as "no translation" so the package fallback kicks in.
  return translated === fullKey ? undefined : translated;
});

registerDataViewLocaleProvider(() => I18n.language);
